var map = {
	"./Blockchain Basics.png": 92,
	"./Cash-Calculator.webp": 9457,
	"./Code-Snippet-Manager.webp": 9042,
	"./Coin-Flipping-Game.webp": 3953,
	"./My-shop.png": 1232,
	"./Photos.webp": 528,
	"./Poll.png": 3596,
	"./Screenshot 2025-11-29 203820.jpg": 6288,
	"./StopWatch.webp": 4936,
	"./accenture.jpg": 8783,
	"./ai-consultation.jpg": 8987,
	"./ai-practice-test.jpg": 3138,
	"./be10x.jpg": 867,
	"./coding-svg-clipart.svg": 8794,
	"./deloittetechnologysimulation.jpg": 8040,
	"./e-voting.jpg": 8984,
	"./event-planner.webp": 4118,
	"./github.webp": 7142,
	"./gotosite.webp": 2233,
	"./hotel-book.png": 1307,
	"./learn-coding-clipart.svg": 5696,
	"./money-mind.png": 8554,
	"./nextjs.jpg": 9273,
	"./portfolio.jpg": 5243,
	"./profile-pic.jpeg": 2876,
	"./profile-pic.jpg": 6963,
	"./profile-pic.png": 5643,
	"./quickpay.jpg": 1202,
	"./react_certificate.jpg": 2442,
	"./restaurant_reservation.png": 6753,
	"./safetrails.jpg": 9947,
	"./sanjeevani.jpg": 8021,
	"./stockmarket.webp": 7053,
	"./theralink.png": 1
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6192;